module.exports = "/OssRegRichId/dist/img/Ae.png";